import { createEl } from '../dom.js';

/**
 * Кнопка "Очистить фильтры". Скрыта, когда нет активных фильтров.
 * onClick вызывает колбэк onClear, чтобы родитель (InlinePanel) мог сбросить state.
 */
export class ClearRefinements {
    /**
     * @param {Element} container
     * @param {{onClear: () => void}} handlers
     */
    constructor(container, { onClear }) {
        this.handlers = { onClear };
        this.el = createEl('button', {
            className: 'doka-clear-refinements',
            type: 'button',
            onClick: () => this.handlers.onClear(),
        }, ['Очистить фильтры']);
        this.el.hidden = true;
        container.appendChild(this.el);
    }

    /**
     * @param {boolean} hasActiveFilters
     */
    update(hasActiveFilters) {
        this.el.hidden = !hasActiveFilters;
    }
}
